import { Component, inject, input, output, untracked } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { AvailableTransitionsClient, TransitionRequestDto, UserRoleMiniDto } from '@unity/clients';
import { WorkflowSelectorSharedComponent } from '@unity/shared/workflow-selector-shared/workflow-selector-shared.component';

@Component({
  selector: 'unity-gridcell-user-role-workflow-actions-shared',
  imports: [WorkflowSelectorSharedComponent],
  templateUrl: './gridcell-user-role-workflow-actions-shared.component.html',
  styleUrl: './gridcell-user-role-workflow-actions-shared.component.scss',
})
export class GridcellUserRoleWorkflowActionsSharedComponent {
  private readonly availableTransitionsClient = inject(AvailableTransitionsClient);

  public readonly $userRole = input.required<UserRoleMiniDto>({ alias: 'userRole' });

  public workflowEvent = output<{ userRole: UserRoleMiniDto; transition: TransitionRequestDto }>();

  protected transitionsResource = rxResource({
    params: () => ({ userRole: this.$userRole() }),
    stream: ({
      params: {
        userRole: { agency_id, user_id, id },
      },
    }) => this.availableTransitionsClient.getAllForUserRoleAsMini(agency_id, user_id, id),
  });

  protected doTransition(transition: TransitionRequestDto) {
    const userRole = untracked(this.$userRole);
    const event = { userRole, transition };
    this.workflowEvent.emit(event);
  }
}
